import { render, staticRenderFns } from "./PrivacyFieldValue.vue?vue&type=template&id=3132f945&scoped=true"
import script from "./PrivacyFieldValue.vue?vue&type=script&lang=js"
export * from "./PrivacyFieldValue.vue?vue&type=script&lang=js"
import style0 from "./PrivacyFieldValue.vue?vue&type=style&index=0&id=3132f945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132f945",
  null
  
)

export default component.exports